import { getAuth, onAuthStateChanged } from 'firebase/auth'
import { useState, useEffect, useContext } from 'react'
import { AuthContext } from './AuthContext'
import { type User } from 'firebase/auth'

export const AuthProvider = (props: WithChildren) => {
  const [user, setUser] = useState<User | null>(null)
  const [error, setError] = useState<any>()
  const [loading, setLoading] = useState<boolean>(true)

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(
      getAuth(),
      (currentUser: User | null) => {
        setLoading(false)
        if (currentUser) {
          setUser(currentUser)
          localStorage.setItem('sijilo_auth_state', 'authenticated')
        } else {
          setUser(null)
          localStorage.removeItem('sijilo_auth_state')
        }
      },
      setError as any
    )
    return () => {
      unsubscribe()
    }
  }, [])

  const clearUser = () => {
    setUser(null)
  }

  return (
    <AuthContext.Provider
      value={{ user, error, loading, clearUser }}
      {...props}
    />
  )
}

export const useAuthState = () => {
  const auth = useContext(AuthContext)
  return {
    ...auth,
    ...auth?.user,
    isAuthenticated: auth?.user != null,
    isLoading: auth.loading
  }
}
